import { DashboardView } from './operations-dashboard.models';

export const DASHBOARD_LABELS: Record<DashboardView, string> = {
  executive: 'Executive overview',
  administrator: 'Administrator',
  'chief-registrar': 'Chief registrar',
  'deputy-chief-registrar': 'Deputy chief registrar',
  registrar: 'Registrar',
  accounting: 'Accounting',
  'chief-accountant': 'Chief accountant',
  finance: 'Finance officer',
  'dokuma-finance': 'Dokuma finance',
};
// Mock authorization mirrors the proposed backend policy; production authorization belongs to the server.
export const ROLE_DASHBOARDS: Record<string, DashboardView[]> = {
  ADMIN: ['administrator', 'executive', 'dokuma-finance'],
  PRODUCT_OWNER: ['administrator', 'executive', 'dokuma-finance'],
  CHIEF_REGISTRAR: ['chief-registrar', 'executive'],
  DEPUTY_CHIEF_REGISTRAR: ['deputy-chief-registrar', 'executive'],
  REGISTRAR: ['registrar'],
  DEEDS_ACCOUNTANT: ['accounting'],
  CHIEF_ACCOUNTANT: ['chief-accountant'],
  FINANCE_OFFICER: ['finance'],
};
export const VIEW_METRICS: Record<DashboardView, string[]> = {
  executive: [
    'register',
    'new',
    'queried',
    'completed',
    'finance-approved',
    'in-office',
  ],
  administrator: [
    'new',
    'pending',
    'queried',
    'completed',
    'active-users',
    'searches',
  ],
  'chief-registrar': [
    'new',
    'pending',
    'completed',
    'revenue',
    'search-users',
    'searches',
  ],
  'deputy-chief-registrar': [
    'new',
    'pending',
    'completed',
    'active-users',
    'inflow',
    'revenue',
    'system-inflow',
    'user-inflow',
    'average-transaction',
    'failure-rate',
  ],
  registrar: ['new', 'pending', 'completed', 'error-rate'],
  accounting: ['revenue', 'transactions', 'statutory'],
  'chief-accountant': [
    'inflow',
    'system-inflow',
    'user-inflow',
    'transactions',
    'revenue',
    'statutory',
    'failure-rate',
  ],
  finance: ['new', 'pending', 'completed'],
  'dokuma-finance': [
    'inflow',
    'system-inflow',
    'user-inflow',
    'transactions',
    'revenue',
    'statutory',
    'failure-rate',
  ],
};
const financial = [
  'wallet-usage',
  'system-usage',
  'user-usage',
  'fee-revenue',
  'user-revenue',
  'payment-channels',
  'bank-status',
  'fee-audit',
  'bank-payments',
  'service-applications',
  'statutory-details',
];
export const VIEW_PANELS: Record<DashboardView, string[]> = {
  executive: [
    'portal-workload',
    'finance-queue',
    'pending-status',
    'status-counts',
    'assigned',
    'application-trend',
    'law-firm-applications',
  ],
  administrator: [
    'training',
    'device-distribution',
    'payment-channels',
    'bottlenecks',
    'assigned',
    'application-stages',
    'fee-audit',
    'transaction-details',
  ],
  'chief-registrar': [
    'alerts',
    'office-applications',
    'processing-times',
    'workflow',
    'assigned',
    'efficiency',
    'error-rates',
    'user-actions',
    'backlog',
    'system-usage',
    'user-usage',
    'portal-workload',
    'finance-queue',
  ],
  'deputy-chief-registrar': [
    'alerts',
    'fee-revenue',
    'user-actions',
    'finance-activity',
    'backlog',
    'workflow',
    'error-rates',
    'application-stages',
    'bank-status',
    'user-usage',
    'system-usage',
    'assigned',
    'portal-workload',
    'finance-queue',
  ],
  registrar: [
    'alerts',
    'bottlenecks',
    'assigned',
    'workflow',
    'service-applications',
    'user-actions',
    'user-processing-times',
    'backlog',
  ],
  accounting: [
    'finance-activity',
    'fee-revenue',
    'service-applications',
    'statutory-details',
    'bank-payments',
  ],
  'chief-accountant': financial,
  finance: ['service-applications', 'recent-activity', 'statutory-details'],
  'dokuma-finance': financial,
};
export const PANEL_LABELS: Record<string, string> = {
  'portal-workload': 'Who holds each application',
  'finance-queue': 'Finance queue: first-time and resubmitted',
  'pending-status': 'Pending applications by status',
  'status-counts': 'Applications by actual status',
  assigned: 'Assigned applications',
  'application-trend': 'Application activity',
  'law-firm-applications': 'Applications by law firm',
  training: 'Law firm training coverage',
  'device-distribution': 'Devices by law firm',
  'payment-channels': 'Payment channel performance',
  bottlenecks: 'Workflow bottlenecks',
  'application-stages': 'Applications by service and stage',
  'fee-audit': 'Fee schedule audit',
  'transaction-details': 'Transaction information',
  alerts: 'Operational alerts',
  'office-applications': 'Applications by office',
  'processing-times': 'Processing time by service',
  workflow: 'Workflow process',
  efficiency: 'Operational efficiency',
  'error-rates': 'Application query rates',
  'user-actions': 'User actions',
  backlog: 'Backlog age',
  'system-usage': 'System funds usage',
  'user-usage': 'User wallet usage',
  'fee-revenue': 'Revenue by fee type',
  'finance-activity': 'Finance and accounting activity',
  'bank-status': 'Bank transaction status',
  'wallet-usage': 'Wallet fund usage',
  'user-revenue': 'Revenue by system user',
  'bank-payments': 'Bank payment history',
  'service-applications': 'Applications by service',
  'statutory-details': 'Statutory fee details',
  'recent-activity': 'Recent activity',
  'user-processing-times': 'Processing time by user',
};
